import { useStaticQuery, graphql } from "gatsby"

import { useI18next } from "gatsby-plugin-react-i18next"

export default function useMenus() {
  const { t, language } = useI18next()
  const lang = language

  const submenus = useStaticQuery(graphql`
    {
      allAffirmations {
        nodes {
          page_contents {
            header_title
            slug
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allScholarshipTargeted {
        nodes {
          page_contents {
            header_title
            slug
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allScholarshipTargeted {
        nodes {
          page_contents {
            header_title
            slug
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allScholarshipGenerals {
        nodes {
          page_contents {
            slug
            header_title
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allScholarshipCollaborations {
        nodes {
          page_contents {
            slug
            header_title
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allResearchRisproMandatories {
        nodes {
          page_contents {
            header_title
            slug
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allResearchRisproInvitations {
        nodes {
          page_contents {
            header_title
            slug
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allResearchRisproCompetitions {
        nodes {
          page_contents {
            slug
            header_title
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      allResearchRisproCollaborations {
        nodes {
          page_contents {
            slug
            header_title
          }
          page_setting {
            submenu_name
          }
          lang
        }
      }
      settings {
        status_page {
          module_name
          page_name
          isActive
        }
      }
    }
  `)

  const flatternStatusPage = submenus.settings.status_page.reduce(
    (acc, val) => {
      if (Array.isArray(val)) {
        acc = [...acc, ...val]
      } else {
        acc = [...acc, val]
      }
      return acc
    },
    []
  ) || []

  const menus = [
    {
      title: t("Tentang"),
      key: "about",
      link: "#",
      submenu: [
        {
          title: t("Selayang Pandang"),
          key: "selayang-pandang",
          module_name: "about",
          page_name: "selayang-pandang",
          link: "/tentang/selayang-pandang/",
        },
        {
          title: t("Visi, Misi, & Fokus"),
          key: "vision-mission",
          module_name: "about",
          page_name: "vision-mission",
          link: "/tentang/visi-misi/",
        },
        {
          title: t("Struktur Organisasi"),
          key: "organization-structures",
          module_name: "about",
          page_name: "organization-structures",
          link: "/tentang/struktur-organisasi/",
        },
        {
          title: t("Manajemen"),
          key: "manajemen",
          link: "#",
          submenu: [
            {
              title: t("Dewan Penyantun"),
              key: "dewan-penyantun",
              module_name: "about",
              page_name: "dewan-penyantun",
              link: "/tentang/manajemen/dewan-penyantun",
            },
            {
              title: t("Dewan Pengawas"),
              key: "dewan-pengawas",
              module_name: "about",
              page_name: "dewan-pengawas",
              link: "/tentang/manajemen/dewan-pengawas",
            },
            {
              title: t("Direksi"),
              key: "direksi",
              module_name: "about",
              page_name: "direksi",
              link: "/tentang/manajemen/direksi",
            },
          ],
        },
        {
          title: t("Testimoni"),
          key: "testimony",
          module_name: "about",
          page_name: "testimony",
          link: "/tentang/testimoni/",
        },
        {
          title: t("Penghargaan"),
          key: "awards",
          module_name: "about",
          page_name: "awards",
          link: "/tentang/penghargaan",
        },
      ],
    },
    {
      title: t("Investasi"),
      key: "investasi",
      link: "#",
      submenu: [
        {
          title: t("Dana Abadi"),
          module_name: "investment",
          page_name: "donation",
          key: "dana-abadi",
          link: "/investasi/dana-abadi/",
        },
        {
          title: t("Skema dan Kebijakan"),
          key: "skema-kebijakan",
          module_name: "investment",
          page_name: "schema-policy",
          link: "/investasi/skema-kebijakan/",
        },
        {
          title: t("Instrumen dan Portofolio"),
          key: "instrumen-portfolio",
          module_name: "investment",
          page_name: "instrument-portfolio",
          link: "/investasi/instrumen-portfolio/",
        },
      ],
    },
    {
      title: t("Beasiswa"),
      key: "scholarship",
      link: "#",
      submenu: [
        {
          title: t("Pendaftaran dan Penjadwalan"),
          key: "scholarship-pendaftaran-penjadwalan",
          module_name: "scholarship",
          page_name: "registration-scheduling",
          link: "/beasiswa/pendaftaran-beasiswa/",
        },
        {
          title: t("Kebijakan Umum"),
          key: "kebijakan-umum",
          module_name: "scholarship",
          page_name: "public-policy",
          link: "/beasiswa/kebijakan-umum/",
        },
        ...(
          submenus.allScholarshipTargeted.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allScholarshipTargeted.nodes.find(d => d.lang === lang).page_setting.submenu_name,
            key: "basiswa-targeted",
            module_name: "scholarship",
            submenu: submenus.allScholarshipTargeted.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "basiswa-targeted",
                  link: "/beasiswa/targeted/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allAffirmations.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allAffirmations.nodes.find(d => d.lang === lang).page_setting.submenu_name,
            key: "basiswa-afirmasi",
            module_name: "scholarship",
            submenu: submenus.allAffirmations.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "basiswa-afirmasi",
                  link: "/beasiswa/afirmasi/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allScholarshipGenerals.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allScholarshipGenerals.nodes.find(d => d.lang === lang)
              .page_setting.submenu_name,
            key: "basiswa-umum",
            module_name: "scholarship",
            submenu: submenus.allScholarshipGenerals.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "basiswa-umum",
                  link: "/beasiswa/umum/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allScholarshipCollaborations.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allScholarshipCollaborations.nodes.find(d => d.lang === lang)
              .page_setting.submenu_name,
            key: "basiswa-kolaborasi",
            module_name: "scholarship",
            submenu: submenus.allScholarshipCollaborations.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "basiswa-kolaborasi",
                  link: "/beasiswa/kolaborasi/" + d.slug,
                }
              })
          }] : []
        )
      ],
    },
    {
      title: t("Awardee"),
      key: "awardee",
      link: "#",
      submenu: [
        {
          title: t("Persiapan Keberangkatan"),
          key: "persiapan-keberangkatan",
          module_name: "awardee",
          page_name: "departure-preparation-policy",
          link: "#",
          submenu: [
            {
              title: t("Kebijakan"),
              key: "persiapan-keberangkatan-kebijakan",
              link: "/awardee/persiapan-keberangkatan/kebijakan/",
            },
            {
              title: t("Angkatan"),
              key: "persiapan-keberangkatan-angkatan",
              link: "/awardee/persiapan-keberangkatan/angkatan/",
            },
          ],
        },
        {
          title: t("Pengayaan Bahasa"),
          key: "pengayaan-bahasa",
          module_name: "awardee",
          page_name: "language-enrichment",
          link: "#",
          submenu: [
            {
              title: t("Kebijakan"),
              key: "pengayaan-bahasa-kebijakan",
              link: "/awardee/pengayaan-bahasa/kebijakan/",
            },
          ],
        },
        {
          title: t("Penerima Beasiswa"),
          key: "penerima-beasiswa",
          module_name: "awardee",
          page_name: "grantee",
          link: "#",
          submenu: [
            {
              title: t("Kebijakan"),
              key: "penerima-beasiswa-panduan",
              link: "/awardee/penerima-beasiswa/panduan/",
            },
            {
              title: "Simonev",
              key: "penerima-beasiswa-simonev",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/Account/LogOn",
            },
            {
              title: "Sipendob",
              key: "penerima-beasiswa-sipendob",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/sipendob/logon",
            },
            {
              title: t("Monev Perguruan Tinggi"),
              key: "penerima-beasiswa-monev",
              link: "https://www.simonev.lpdp.kemenkeu.go.id/Account/LogOn",
            },
          ],
        },
        {
          title: t("Alumni"),
          key: "alumni",
          module_name: "awardee",
          page_name: "alumni",
          link: "#",
          submenu: [
            {
              title: t("Pengelolaan Alumni"),
              key: "alumni-panduan",
              link: "/awardee/alumni/",
            },
            {
              title: t("Featured Alumni"),
              key: "featured-alumni",
              link: "/awardee/alumni/featured-alumni/",
            },
            {
              title: t("Mata Garuda"),
              key: "mata-garuda/",
              link: "https://matagaruda.org/",
            },
          ],
        },
        {
          title: t("Kontribusi"),
          module_name: "awardee",
          page_name: "contribution",
          key: "kontribusi",
          link: "/awardee/kontribusi/",
        },
      ],
    },
    {
      title: t("Riset"),
      key: "research",
      link: "#",
      submenu: [
        {
          title: t("Pendaftaran dan Jadwal"),
          key: "research-pendaftaran-penjadwalan",
          module_name: "research",
          page_name: "research-registration-scheduling",
          link: "/riset/pendaftaran-penjadwalan/",
        },
        {
          title: t("Kebijakan Umum RISPRO"),
          key: "kebijakan-rispros-umum",
          module_name: "research",
          page_name: "research-public-policy",
          link: "/riset/kebijakan-rispros-umum/",
        },
        ...(
          submenus.allResearchRisproCompetitions.nodes.find(d => d.lang === lang).page_contents.length ? [{
            title: submenus.allResearchRisproCompetitions.nodes.find(
              d => d.lang === lang
            ).page_setting.submenu_name,
            key: "rispro-kompetisi",
            module_name: "research",
            link: "#",
            submenu: submenus.allResearchRisproCompetitions.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "rispro-kompetisi",
                  link: "/riset/kompetisi/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allResearchRisproInvitations.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allResearchRisproInvitations.nodes.find(
              d => d.lang === lang
            ).page_setting.submenu_name,
            key: "rispro-invitasi",
            module_name: "research",
            link: "#",
            submenu: submenus.allResearchRisproInvitations.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: `rispro-invitasi.${d.slug}`,
                  module_name: "rispro-invitasi",
                  link: "/riset/invitasi/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allResearchRisproMandatories.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allResearchRisproMandatories.nodes.find(
              d => d.lang === lang
            ).page_setting.submenu_name,
            key: "rispro-mandatori",
            module_name: "research",
            link: "#",
            submenu: submenus.allResearchRisproMandatories.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  module_name: "rispro-mandatori",
                  link: "/riset/mandatori/" + d.slug,
                }
              })
          }] : []
        ),
        ...(
          submenus.allResearchRisproCollaborations.nodes.find(d => d.lang === lang).page_contents.length > 0 ? [{
            title: submenus.allResearchRisproCollaborations.nodes.find(
              d => d.lang === lang
            ).page_setting.submenu_name,
            key: "rispro-collaboration",
            link: "#",
            submenu: submenus.allResearchRisproCollaborations.nodes
              .find(d => d.lang === lang)
              .page_contents.map(d => {
                return {
                  title: d.header_title,
                  key: d.slug,
                  link: "/riset/kolaborasi/" + d.slug,
                }
              })
          }] : []
        )
      ],
    },
    {
      title: t("Grantees"),
      key: "grantees",
      link: "#",
      submenu: [
        {
          title: t("Daftar Grantees"),
          key: "daftar-grantees",
          module_name: "grantee",
          page_name: "list-of-grantees",
          link: "/grantees/daftar-grantees/",
        },
        {
          title: t("Kisah Inpiratif RISPRO"),
          key: "kisah-inspiratif-rispro",
          module_name: "grantee",
          page_name: "inspiration-story",
          link: "/grantees/kisah-inspiratif-rispro/",
        },
        {
          title: t("RISPRO Tech Brief"),
          key: "rispro-tech-brief",
          module_name: "grantee",
          page_name: "rispro-tech-brief",
          link: "/grantees/rispro-tech-brief/",
        },
      ],
    },
    {
      title: t("Informasi"),
      key: "information",
      link: "#",
      submenu: [
        {
          title: t("Laporan"),
          key: "laporan",
          link: "#",
          submenu: [
            {
              title: t("Laporan Keuangan"),
              key: "laporan-keuangan",
              module_name: "information",
              page_name: "laporan-keuangan",
              link: "/informasi/laporan-keuangan/",
            },
            {
              title: t("Laporan Tahunan"),
              key: "laporan-tahunan",
              module_name: "information",
              page_name: "laporan-tahunan",
              link: "/informasi/laporan-tahunan/",
            },
            {
              title: t("Laporan Kinerja"),
              key: "laporan-kinerja",
              module_name: "information",
              page_name: "laporan-kinerja",
              link: "/informasi/laporan-kinerja/",
            },
            {
              title: t("Infografik"),
              key: "infografis",
              module_name: "information",
              page_name: "infografis",
              link: "/informasi/infografik/",
            },
          ],
        },
        {
          title: t("Berita"),
          key: "berita",
          module_name: "information",
          page_name: "news",
          link: "/informasi/berita",
        },
        {
          title: t("Karir"),
          key: "karir",
          module_name: "information",
          page_name: "careers",
          link: "/informasi/karir",
        },
        {
          title: t("Live"),
          key: "live",
          module_name: "information",
          page_name: "live",
          link: "/informasi/live",
        },
        {
          title: "FAQ",
          key: "faq",
          link: "#",
          submenu: [
            {
              title: t("Daftar Pertanyaan"),
              key: "daftar-pertanyaan",
              link: "https://bantuan.lpdp.kemenkeu.go.id/kb",
            },
            {
              title: t("Investasi"),
              key: "faq-investasi",
              link: "/investasi/dana-abadi/",
            },
            {
              title: t("Beasiswa"),
              key: "faq-beasiswa",
              link: "/beasiswa/kebijakan-umum/",
            },
            {
              title: t("Riset"),
              key: "faq-riset",
              link: "/riset/kebijakan-rispros-umum/",
            },
          ],
        },
        {
          title: t("Hubungi Kami"),
          key: "contact-us",
          module_name: "information",
          page_name: "contact-us",
          link: "/informasi/hubungi-kami/",
        },
      ],
    },
  ];

  const newMenus = menus.map(menu => {
    const filteredStatus = flatternStatusPage.filter(
      d => d.module_name === menu.key
    )

    if (filteredStatus.length > 0) {
      return {
        ...menu,
        submenu: menu.submenu.filter(dd => {
          if (!dd.page_name) {
            return true
          }
          return filteredStatus.find(
            d => d.page_name === dd.page_name && d.isActive === 1
          )
        }).map((thirdmenu) => {
          return {
            ...thirdmenu,
            ...(thirdmenu.submenu !== undefined ? {
              submenu: thirdmenu.submenu.filter(ddd => {
                if (!ddd.page_name) {
                  // console.log('show', ddd)
                  return true
                }
                return filteredStatus.find(
                  d => {
                    // console.log(ddd.page_name, d.page_name === ddd.page_name && d.isActive === 1)
                    return d.page_name === ddd.page_name && d.isActive === 1
                  }
                )
              })
            } : {})
          }
        }),
      }
    }

    return menu
  })

  return newMenus
}
